/**
 * API 请求封装
 * 统一处理请求地址、认证 token、错误处理
 */
import config from './config'

/**
 * 获取存储的 token
 */
function getToken() {
  return localStorage.getItem('adminToken') || ''
}

/**
 * 统一请求方法
 * @param {string} path - API 路径（如 /admin/user/list）
 * @param {object} options - fetch 选项
 * @returns {Promise<object>}
 */
async function request(path, options = {}) {
  // 运行时直连后端绝对地址（与 user 项目一致，靠 CORS，不用 devServer 代理）
  const url = `${config.baseUrl}${config.apiVersion}${path}`
  
  const defaultHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${getToken()}`
  }
  
  const fetchOptions = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers
    }
  }
  
  try {
    const response = await fetch(url, fetchOptions)
    
    // 检查 HTTP 状态码
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`)
    }
    
    const data = await response.json()
    
    // 登录成功时存储 token
    if (data.code === 0 && data.data && data.data.token) {
      localStorage.setItem('adminToken', data.data.token)
    }
    
    // 统一错误处理
    if (data.code !== 0) {
      // token 过期或未登录
      if (data.code === 401) {
        localStorage.removeItem('adminToken')
        window.location.href = '/login'
        throw new Error('登录已过期，请重新登录')
      }
      throw new Error(data.message || '请求失败')
    }
    
    return data
  } catch (error) {
    console.error('API 请求错误:', error)
    // 网络错误时提供更友好的提示
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      throw new Error('网络连接失败，请检查后端服务是否启动')
    }
    throw error
  }
}

// 导出请求方法
export default {
  get: (path, params) => {
    const queryString = params ? '?' + new URLSearchParams(params).toString() : ''
    return request(path + queryString, { method: 'GET' })
  },
  
  post: (path, data) => {
    return request(path, {
      method: 'POST',
      body: JSON.stringify(data)
    })
  },
  
  put: (path, data) => {
    return request(path, {
      method: 'PUT',
      body: JSON.stringify(data)
    })
  },
  
  delete: (path, params) => {
    const queryString = params ? '?' + new URLSearchParams(params).toString() : ''
    return request(path + queryString, { method: 'DELETE' })
  }
}
